import React, { useEffect, useState } from "react";
import {
  Box,
  Text,
  Tabs,
  TabList,
  TabPanels,
  Tab,
  TabPanel,
} from "@chakra-ui/react";
import ReportNewProject from "../components/ReportNewProject";
import AttendanceReport from "../components/AttendanceReport";
import { useDispatch } from "react-redux";
import { fetchAllEvents } from "../redux/slices/eventRegistrationSlice";
import { fetchMembershipType } from "../redux/slices/membershipTypeSlice";
import { clearsearchFilter } from "../redux/slices/searchFilterSlice";

const Reports = () => {
  const dispatch = useDispatch();
  const [tabIndex, setTabIndex] = useState(0);

  useEffect(() => {
    dispatch(fetchAllEvents());
    dispatch(fetchMembershipType());
    dispatch(clearsearchFilter());
  }, [dispatch]);

  const handleTabsChange = (index) => {
    setTabIndex(index);
    dispatch(clearsearchFilter());
  };

  return (
    <>
      <Box bg={"#FFFFFF"} py={"30px"}>
        <Box
          justifyContent={"flex-start"}
          alignItems={"center"}
          gap={"20px"}
          borderBottom={"1px solid #B4B1B1"}
          py={"20px"}
          px={"20px"}
        >
          <Text fontSize={"18px"} fontWeight={"500"}>
            Report
          </Text>
        </Box>

        <Box py={5} px={"20px"} minH={"80vh"}>
          <Tabs
            index={tabIndex}
            onChange={handleTabsChange}
            variant="unstyled"
            isLazy
          >
            <TabList borderBottom={"1px solid #E2E8F0"} gap={4} mb={6}>
              <Tab
                fontSize={"16px"}
                fontWeight={"500"}
                pb={3}
                pt={1}
                px={4}
                color={"#8A8C8E"}
                borderBottom={"3px solid transparent"}
                _selected={{
                  color: "#22944E",
                  borderBottom: "3px solid #22944E",
                  fontWeight: "600",
                }}
                _focus={{ outline: "none", boxShadow: "none" }}
              >
                Event Report
              </Tab>
              <Tab
                fontSize={"16px"}
                fontWeight={"500"}
                pb={3}
                pt={1}
                px={4}
                color={"#8A8C8E"}
                borderBottom={"3px solid transparent"}
                _selected={{
                  color: "#22944E",
                  borderBottom: "3px solid #22944E",
                  fontWeight: "600",
                }}
                _focus={{ outline: "none", boxShadow: "none" }}
              >
                Attendance Report
              </Tab>
            </TabList>

            <TabPanels>
              <TabPanel p={0}>
                <ReportNewProject />
              </TabPanel>
              <TabPanel p={0}>
                <AttendanceReport />
              </TabPanel>
            </TabPanels>
          </Tabs>
        </Box>
      </Box>
    </>
  );
};

export default Reports;
